import { render } from "./Hero.vue?vue&type=template&id=03e210f2&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=03e210f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03e210f2"

export default script